import { forkJoin, Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';

export class MultiTranslateHttpLoader implements TranslateLoader {

    constructor(private http: HttpClient, public baseUrl: string = './assets/i18n', public resources: string[]) { }

    public getTranslation(lang: string): Observable<any> {

        return forkJoin(this.resources.map(config => {
            let path: string = `${this.baseUrl}/${lang}/${config}.json`;
            let headers: HttpHeaders = new HttpHeaders();
            headers = headers.append('Cache-control', 'no-cache');
            headers = headers.append('Cache-control', 'no-store');
            headers = headers.append('Expires', '0');
            headers = headers.append('Pragma', 'no-cache');

            //console.log(path, headers)
            return this.http.get(path, { headers: headers });
        })).pipe(map(response => {
            return response.reduce((a, b) => {
                return Object.assign(a, b);
            });
        }));
    }
}
